import type { AxiosInstance, InternalAxiosRequestConfig } from "axios";

declare module "axios" {
  interface AxiosRequestConfig {
    Action?: string;
  }
}

function actionInjection(config: InternalAxiosRequestConfig<any>) {
  const action = config.Action;
  delete config.Action;

  config.params = action ? { Action: action, ...config.params } : config.params;

  return config;
}

export function injectAction(ins: AxiosInstance): AxiosInstance {
  ins.interceptors.request.use(actionInjection);
  return ins;
}
